export function ImageSliderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33333 2.5C2.8731 2.5 2.5 2.8731 2.5 3.33333V12.6667C2.5 13.1269 2.8731 13.5 3.33333 13.5H12.6667C13.1269 13.5 13.5 13.1269 13.5 12.6667V3.33333C13.5 2.8731 13.1269 2.5 12.6667 2.5H3.33333ZM1.5 3.33333C1.5 2.32081 2.32081 1.5 3.33333 1.5H12.6667C13.6792 1.5 14.5 2.32081 14.5 3.33333V12.6667C14.5 13.6792 13.6792 14.5 12.6667 14.5H3.33333C2.32081 14.5 1.5 13.6792 1.5 12.6667V3.33333Z"
        fill="#101010"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6665 5.16669C5.39036 5.16669 5.1665 5.39054 5.1665 5.66669C5.1665 5.94283 5.39036 6.16669 5.6665 6.16669C5.94265 6.16669 6.1665 5.94283 6.1665 5.66669C6.1665 5.39054 5.94265 5.16669 5.6665 5.16669ZM4.1665 5.66669C4.1665 4.83826 4.83808 4.16669 5.6665 4.16669C6.49493 4.16669 7.1665 4.83826 7.1665 5.66669C7.1665 6.49511 6.49493 7.16669 5.6665 7.16669C4.83808 7.16669 4.1665 6.49511 4.1665 5.66669Z"
        fill="#101010"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3133 6.31313C10.5085 6.11787 10.8251 6.11787 11.0204 6.31313L14.3537 9.64647C14.549 9.84173 14.549 10.1583 14.3537 10.3536C14.1585 10.5488 13.8419 10.5488 13.6466 10.3536L10.6668 7.37379L3.68705 14.3536C3.49179 14.5488 3.1752 14.5488 2.97994 14.3536C2.78468 14.1583 2.78468 13.8417 2.97994 13.6465L10.3133 6.31313Z"
        fill="#101010"
      />
    </svg>
  )
}
